import React from "react";
import logo_legal_resident from "~/assets/mainPage/cards/IMG_Legal_560x260.jpg";

export const CardsLegalResident = ({handleCheckUserRegistration, handleRate, openInstructionLegalResident}) => {
    return (
        <>
            <ul className="main-page-card">
                <li className={"main-page-card-li"}>
                    <div className="image-text-container">
                        <img
                            src={logo_legal_resident}
                            alt='legal_resident'
                            className={"logo-legal-resident"}
                        />
                        <div className="text-overlay">
                            <h1 className={"text-overlay-h1-main"}>Рахунок онлайн для Юридичної особи</h1>
                            <p className={"text-overlay-p-main"}>Відкриття рахунку для юридичних осіб ще зручніше – відтепер це відбувається дистанційно, без відвідування відділень банку.</p>
                        </div>
                        <nav className="button-overlay">
                            <div style={{display: 'flex', gap: '6px'}}>
                                <button
                                    className="main-page-button-open"
                                    onClick={handleCheckUserRegistration}
                                >
                                    Відкрити
                                </button>
                            </div>
                            <div className="button-overlay-content">
                                <button
                                    onClick={openInstructionLegalResident}
                                >
                                    Інструкція
                                </button>
                                <button
                                    onClick={handleRate}
                                >
                                    Тарифи
                                </button>
                            </div>
                        </nav>
                    </div>
                </li>
            </ul>
        </>
    )
}